import script from "./PaymentWalletModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentWalletModal.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentWalletModal.vue?vue&type=style&index=0&id=e48e4ede&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e48e4ede"]])

export default __exports__